import {
  FETCH_ROLES_SUCCESS,
  FETCH_DIVISIONS_SUCCESS,
  FETCH_REGIONS_SUCCESS,
  GENERATE_PRESIGNED_URL,
  GET_ALL_FORMS,
  GET_ALL_GUARD_LOCATIONS,
  GET_NOTIFICATION,
  POST_GENERATE_PRESIGNED_URL,
  READ_NOTIFICATION,
  SAVE_ALL_GUARD_LOCATIONS,
  SAVE_NOTIFICATION,
  FETCH_ROLES_FAILURE,
  FETCH_DIVISIONS_FAILURE,
  FETCH_REGIONS_FAILURE,
  FETCH_RANGES_SUCCESS,
  FETCH_RANGES_FAILURE,
  FETCH_ROUNDS_SUCCESS,
  FETCH_ROUNDS_FAILURE,
  FETCH_BEATS_SUCCESS,
  FETCH_BEATS_FAILURE,
  FETCH_COMPARTMENTS_SUCCESS,
  FETCH_COMPARTMENTS_FAILURE,
  SAVE_ALL_VEHICLE_LOCATIONS,
  SAVE_ALL_BEATS_LOCATIONS,
  GET_ALL_USER,
  SAVE_ALL_USER,
} from "./actionTypes";

const INIT_STATE = {
  layoutType: [],
  locations: [],
  location: [],
  notifications: [],
  readnotifications: 0,
  fileName: "",
  divisions: [],
  regions: [],
  roles: [],
  error: null,
  allUsers:[]

};

const Common = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_ALL_FORMS:
      return {
        ...state,
        layoutType: action.payload,
      };
    case GET_ALL_GUARD_LOCATIONS:
      return {
        ...state,
        locations: action.payload,
      };
    case SAVE_ALL_GUARD_LOCATIONS:
      return {
        ...state,
        location: action.payload,
      };
      case SAVE_ALL_VEHICLE_LOCATIONS:
      return {
        ...state,
        vehicleLocation: action.payload,
      };
      case SAVE_ALL_BEATS_LOCATIONS:
        return {
          ...state,
          beatsLocations: action.payload,
        };
    case SAVE_NOTIFICATION:
      return {
        ...state,
        notifications: action.payload,
      };
    case READ_NOTIFICATION:
      return {
        ...state,
        readnotifications: action.payload,
      };
    case GENERATE_PRESIGNED_URL:
      return {
        ...state,
        fileName: action.payload,
      };
    case POST_GENERATE_PRESIGNED_URL:
      return {
        ...state,
        presignedUrl: action.payload,
      };
      case GET_ALL_USER:
      return {
        ...state,
        allUsers: action.payload,
      };
      case SAVE_ALL_USER:
      return {
        ...state,
        allUsersnvehicle: action.payload,
      };

    // 🔹 Handle Roles
    case FETCH_ROLES_SUCCESS:
      return {
        ...state,
        roles: action.payload, // Ensure the correct data structure
      };
    case FETCH_ROLES_FAILURE:
      return {
        ...state,
        error: action.error,
      };

    // 🔹 Handle Divisions
    case FETCH_DIVISIONS_SUCCESS:
      return {
        ...state,
        divisions: action.payload,
      };
    case FETCH_DIVISIONS_FAILURE:
      return {
        ...state,
        error: action.error,
      };

    // 🔹 Handle Regions
    case FETCH_REGIONS_SUCCESS:
      return {
        ...state,
        regions: action.payload,
      };
    case FETCH_REGIONS_FAILURE:
      return {
        ...state,
        error: action.error,
      };

      // 🔹 Handle ranges
    case FETCH_RANGES_SUCCESS:
      return {
        ...state,
        ranges: action.payload,
      };
    case FETCH_RANGES_FAILURE:
      return {
        ...state,
        error: action.error,
      };

         // 🔹 Handle rounds
    case FETCH_ROUNDS_SUCCESS:
      return {
        ...state,
        rounds: action.payload,
      };
    case FETCH_ROUNDS_FAILURE:
      return {
        ...state,
        error: action.error,
      };
      case FETCH_BEATS_SUCCESS:
        return {
          ...state,
          beats: action.payload,
        };
      case FETCH_BEATS_FAILURE:
        return {
          ...state,
          error: action.error,
        };
        case FETCH_COMPARTMENTS_SUCCESS:
        return {
          ...state,
          compartments: action.payload,
        };
      case FETCH_COMPARTMENTS_FAILURE:
        return {
          ...state,
          error: action.error,
        };

    default:
      return state;
  }
};

export default Common;
